import { Component, ElementRef, HostListener, inject, OnInit, output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InstitutionService } from '../../../services/institution/institution.service';
import { Institution } from '../../../interfaces/responses/institution.interface';

@Component({
  selector: 'app-filters',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.scss'
})
export class FiltersComponent implements OnInit {
  private _eref = inject(ElementRef);
  private _fb = inject(FormBuilder);
  private institutionService = inject(InstitutionService);

  isShowFilters = false;
  institutions: Institution[] = [];
  today = new Date().toISOString().split('T')[0];

  statusOptions = [
    { value: 'PENDING_APPROVAL',     label: 'Pending' },
    { value: 'APPROVED',             label: 'Approved' },
    { value: 'ACCEPTED',             label: 'Accepted' },
    { value: 'COUNTERED',            label: 'Countered' },
    { value: 'PROCESSING',           label: 'Processing' },
    { value: 'PENDING_DISBURSEMENT', label: 'Pending Disbursement' },
    { value: 'DISBURSED',            label: 'Disbursed' },
    { value: 'ACTIVE',               label: 'Active' },
    { value: 'REJECTED',             label: 'Rejected' },
    { value: 'DEFAULTED',            label: 'Defaulted' },
    { value: 'COMPLETED',            label: 'Completed' },
    { value: 'CANCELLED',            label: 'Cancelled' },
    { value: 'COUNTER_REJECTED',     label: 'Ctr. Rejected' },
  ];

  formData: FormGroup = this._fb.group({
    startDate:       [''],
    endDate:         [''],
    status:          [''],
    institutionId:   [''],
    institutionName: [''],
    minAmount:       [null],
    maxAmount:       [null],
  });

  onSaveEvent  = output<FormGroup>();
  resetClickEvent = output<void>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isShowFilters = false;
    }
  }

  ngOnInit() {
    this.institutionService.getPaginatedInstitutions({ paginate: false }).subscribe({
      next: (res) => this.institutions = res.data,
      error: () => {}
    });
  }

  get activeFilterCount(): number {
    const v = this.formData.value;
    return [v.startDate, v.endDate, v.status, v.institutionId, v.minAmount, v.maxAmount]
      .filter(x => x !== null && x !== undefined && x !== '').length;
  }

  onClick() {
    this.isShowFilters = !this.isShowFilters;
  }

  onResetClick() {
    this.formData.reset({ startDate: '', endDate: '', status: '', institutionId: '', institutionName: '', minAmount: null, maxAmount: null });
    this.isShowFilters = false;
    this.resetClickEvent.emit();
  }

  onSaveFilters() {
    this.isShowFilters = false;
    const institutionId = this.formData.value.institutionId;
    const institution = this.institutions.find(i => i.id === institutionId);
    this.formData.patchValue({ institutionName: institution?.name || '' }, { emitEvent: false });
    this.onSaveEvent.emit(this.formData);
  }
}
